var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.8237 10.8611C23.1082 11.1474 23.2679 11.5346 23.2679 11.9382C23.2679 12.3418 23.1082 12.729 22.8237 13.0153L17.4153 18.5L22.8237 23.9083C23.1082 24.1946 23.2679 24.5818 23.2679 24.9854C23.2679 25.389 23.1082 25.7762 22.8237 26.0625C22.6817 26.2057 22.5127 26.3193 22.3265 26.3969C22.1403 26.4745 21.9406 26.5144 21.739 26.5144C21.5373 26.5144 21.3376 26.4745 21.1514 26.3969C20.9652 26.3193 20.7963 26.2057 20.6542 26.0625L14.1765 19.5847C14.0333 19.4427 13.9196 19.2737 13.842 19.0875C13.7645 18.9014 13.7245 18.7017 13.7245 18.5C13.7245 18.2983 13.7645 18.0986 13.842 17.9124C13.9196 17.7263 14.0333 17.5573 14.1765 17.4153L20.6542 10.8611C20.7963 10.7179 20.9652 10.6043 21.1514 10.5267C21.3376 10.4491 21.5373 10.4092 21.739 10.4092C21.9406 10.4092 22.1403 10.4491 22.3265 10.5267C22.5127 10.6043 22.6817 10.7179 22.8237 10.8611Z",
    fill: "#3BB77E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow-left.452f10c91e96086d8ab45f4c0c5d2485.svg";
export { ForwardRef as ReactComponent };